<template lang="pug">
  v-container
    div.text-md.font-semibold.primary--text {{ $t('performance') }}
    v-row.mt-2
      v-col
        v-card.round-xl.box-border.pa-4(outlined)
          div.text-md.font-semibold.basic600--text {{ $t('total_sms_sent') }}
          v-progress-circular.mt-4(v-if="isFetchingReport" :width="4" :size="40" color="primary400" indeterminate)
          div.heading-4.mt-4(v-else) {{ performance.total_sent }}
      v-col
        v-card.round-xl.box-border.pa-4(outlined)
          div.text-md.font-semibold.basic600--text {{ $t('success_rate') }}
          v-progress-circular.mt-4(v-if="isFetchingReport" :width="4" :size="40" color="primary400" indeterminate)
          div.heading-4.mt-4(v-else) {{ performance.success_rate }}%
    
    v-row(align="center" v-if="!isMobileScreen")
      v-col(cols="12")
        .d-flex.align-center.justify-end
          yc-pagination-custom.ml-4.my-auto(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" :text="$t('item_list')" @input="pageChanged")
          slot(name="actions")

    .yc-table
      v-data-table.mt-sm-4.pb-16(:headers="headers" :items="events" :items-per-page="pageSize" :loading="isFetching" hide-default-footer disable-sort)
        template(v-slot:no-data)
          .mt-16
            v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
            .mt-2.p2.basic600--text {{ $t('no_list_available') }}
        template(#item.success_rate="{ item }")
          div.text-end {{ item.success_rate }}%
        template(#item.created="{ item }")
          div.text-end {{ item.created | displayDate }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SmsBlastReport',
  components: {},
  props: ['group'],
  data () {
    return {
      isFetching: false,
      isFetchingReport: false,
      performance: {},
      events: [],
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      headers: [
        {
          text: this.$t('event'),
          value: 'name',
          enable: true,
          class: 'text-table-header'
        },
        {
          text: this.$t('success_rate'),
          value: 'success_rate',
          enable: true,
          class: 'text-table-header text-end'
        },
        {
          text: this.$t('sent_on'),
          value: 'created',
          enable: true,
          class: 'text-table-header text-end'
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    pageSize() {
      this.fetchBlastEvents(1)
    },
  },
  created () {
    this.fetchBlastEvents(1)
    this.fetchBlastReport()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchBlastEvents(page) {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page,
        method: 'sms',
        group: this.group,
      }
      this.$axios.get(`/connect/${this.company.slug}/blast_events`, { params })
        .then(resp => {
          if (resp.data.results) {
            this.events = resp.data.results
          }
          this.totalCount = resp.data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchBlastReport() {
      this.isFetchingReport = true
      const params = {
        method: 'sms'
      }
      this.$axios.get(`/connect/${this.company.slug}/groups/${this.group}/blast_report`, { params })
        .then(resp => {
          if (resp.data.sms) {
            this.performance = resp.data.sms
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingReport = false
        })
    },
    pageChanged(num) {
      this.fetchBlastEvents(num)
    }
  }
}
</script>

<style scoped>
.box-border {
  border: var(--v-basic500) solid 1px;
}
</style>